// extracted by mini-css-extract-plugin
var _1 = "StarProgressTest__avatar--J6yEH";
var _2 = "StarProgressTest__bg--FHo97";
var _3 = "StarProgressTest__button--cu5u4";
var _4 = "StarProgressTest__container--v0fVh";
var _5 = "StarProgressTest__main--l62WZ TrainerGeneral__starProgress--bSkTx";
var _6 = "StarProgressTest__summary--vlRIw";
export { _1 as "avatar", _2 as "bg", _3 as "button", _4 as "container", _5 as "main", _6 as "summary" }
